<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="700"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  [enableBodyScroll]="true"
  (onHidden)="closeDialog()"
>
  <form [formGroup]="form">

    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <dx-lookup
          [dataSource]="findAllLocalSites()"
          [value]="selectedSite?.id"
          valueExpr="id"
          displayExpr="libelle"
          [searchEnabled]="true"
          [placeholder]="sitePlaceholder"
          (onSelectionChanged)="onChangeSite($event)"
          [disabled]="!canModify()"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box placeholder="Libellé" formControlName="libelle" [disabled]="!canModify()"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box placeholder="Code" formControlName="code" [disabled]="!canModify()"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Siret">Siret <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box placeholder="Siret" formControlName="siret" [disabled]="!canModify()"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Adresse email">Adresse email</div>
      <div class="value">
        <dx-text-box placeholder="Adresse email" formControlName="emailAddress" [disabled]="!canModify()"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="PointLivraison">Point de livraison <span class="danger-color">*</span></div>
      <div class="value">
        <yo-tagbox
          #plcList
          [data]="allPlcs"
          [selectedItems]="selectedPlcs"
          [disabled]="!canModify()"
        >
        </yo-tagbox>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Actif">Actif <span class="danger-color">*</span></div>
      <div class="value">
        <dx-check-box [value]="true" formControlName="actif" [disabled]="!canModify()"></dx-check-box>
      </div>
    </div>

  </form>

  <div class="d-flex justify-content-end">
    <yo-button
      type="submit"
      iconClass="fas fa-save"
      [theme]="ButtonThemeEnum.SAVE"
      (onClick)="save()"
      [hidden]="!canModify()"
      tooltip="Enregistrer">
    </yo-button>
    <yo-button
      class="mg-l-5"
      [theme]="ButtonThemeEnum.CANCEL"
      (onClick)="closeDialog()"
      tooltip="Fermer"
      iconClass="fas fa-times">
    </yo-button>
  </div>

</dx-popup>
